import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["a learner", "a coder", "a developer"];
    const[text, setText] = useState('');
    const[delta, setDelta] = useState(120);
    const period = 360;

    useEffect(() => {
        let ticker = setInterval(() =>{
            tick();
        }, delta)
        return () => clearInterval(ticker);
        // eslint-disable-next-line
    }, [text])

    const tick = () => {
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if(isDeleting) {
            setDelta(prevDelta => prevDelta / 1.25)
        }

        if(!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(period);
        }
    }

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <h1>
                            {`Hi, I'm Shobhit`}
                            <span className="wrap"><br/> {text}</span>
                        </h1>
                        <br></br>
                        <p>About Me!</p>
                        <p className="text-white">I'm a passionate learner, an android app developer, and an open source contributor who worked as a project intern. I used to enjoy learning from peers and implementing their best practices to contribute to the software development community.
</p>
                        <p className="text-white">I am dedicated and committed to show interest in learning new frameworks and technologies to enhance my software development skills.</p>
                        <button 
                            onClick={() => {
                                window.open('https://www.linkedin.com/in/shobhit-soni')
                            }}
                            
                        >Let's Connect!
                        </button>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={headerImg} alt="Header Img" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}